<template>
  <modal v-bind="{ ...$attrs, ...$props }" @close="$emit('close')">
    <v-flex class="text-xs-left" slot="title">{{ title }}</v-flex>

    <div v-if="description">{{ description }}</div>

    <v-layout slot="actions">
      <v-flex>
        <v-btn color="warning" @click="$emit('close')">
          <v-icon>mdi-cancel mr-2</v-icon>

          {{ cancelText }}
        </v-btn>

        <v-btn class="float-right" color="primary" @click="$emit('confirm')">
          <v-icon>mdi-check mr-2</v-icon>

          {{ confirmText }}
        </v-btn>
      </v-flex>
    </v-layout>
  </modal>
</template>

<script>
import Modal from '../material/Modal';

// @vuese
// Modal potwierdzenia
// @group Modals
export default {
  components: { Modal },
  props: {
    // Tytuł
    title: { type: String, required: true },

    // Treść / opis
    description: { type: String, required: false },

    // Tekst anulowania
    cancelText: { type: String, default: 'Nie' },

    // Tekst potwierdzenia
    confirmText: { type: String, default: 'Tak' }
  }
};
</script>
